<template>
  <el-drawer
    title="Workouts"
    :visible.sync='workoutsVisible'
    direction="rtl"
    size="850px"
    :before-close='closeWorkouts'
    close-on-press-escape
    :wrapperClosable='false'
  >
    <div class="workout-header">
      <div class="workout-actions">
        <el-button v-if="addWorkout" class="add-workout-back-btn" @click="backAddWorkout" round size="small" type='primary' plain icon="el-icon-back">{{ woFormTwo ? 'Back' : 'Cancel' }}</el-button>
        <el-button v-if="!addWorkout" class="add-workout-btn" @click="startAddWorkout" round size="small" type='primary' icon="el-icon-plus">Add Workout</el-button>
      </div>
    </div>

    <!-- start Workout Table -->
    <template v-if="!addWorkout">
      <el-table :data="woData">
        <el-table-column property="name" label="Name" sortable>
          <template slot-scope="scope">
            <span :title="scope.row.name" class="wo-name-cell">
              {{ scope.row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="Type"
          column-key="type"
          sortable
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.type === 'Strength' && 'primary' || scope.row.type === 'Cardio' && 'danger' || scope.row.type === 'Endurance' && 'warning' || scope.row.type === 'Flexibility' && 'success'"
              disable-transitions
              class="wo-type"
            >
              {{ scope.row.type }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column property="focus" label="Focus" sortable/>
        <el-table-column align="right">
          <template slot-scope="scope">
            
            <el-dropdown trigger="click">
              <el-button size="small" class="more-btn" icon="el-icon-more" circle></el-button>
              <el-dropdown-menu class="wo-table-dropdown">
                <el-link @click.native.prevent="editWorkout(scope.$index, woData)">
                  <el-dropdown-item icon="el-icon-edit">
                    View &amp; Edit
                  </el-dropdown-item>
                </el-link>
                <el-link @click.native.prevent="deleteWorkout(scope.$index, woData)">
                  <el-dropdown-item class="delete-btn" icon="el-icon-delete" divided>
                    Delete
                  </el-dropdown-item>
                </el-link>
              </el-dropdown-menu>
            </el-dropdown>

          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- end Workout Table -->

    <!-- start Add Workout -->
    <template v-if="addWorkout">
      <h2>{{ editWO ? 'Edit workout' : addWorkoutText }}</h2>
      <form id="workoutForm" class="workout-form--content" @submit.prevent='workoutFormHandler()'>
        
        <template v-if="woFormOne">
          <label>name</label>
          <input
            v-model="woName"
            ref="workoutName"
            type="text"
            placeholder="Create a name for your workout"
          />
          <el-row :gutter="16">
            <el-col :span="12">
              <label>type</label>
              <el-select v-model="woType" placeholder="Select the workout type" filterable>
                <el-option
                  v-for="item in types"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-col>
            <el-col :span="12">
              <label>focus</label>
              <el-select v-model="woFocus" placeholder="Select the workout focus" filterable>
                <el-option
                  v-for="item in focuses"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-col>
          </el-row>
        </template>
        
        <template v-if="woFormTwo">
          <div
            v-for="(circuit, index) in circuits"
            :key="index"
            :prop="'circuit.exercises.' + index + '.value'"
            class="circuit"
          >
            <hr v-if="index > 0"/>
            <div class="title">
              <h3><i class="el-icon-coin"/> {{ 'Circuit ' + (index + 1) }}</h3>
              <div class="title--actions">
                <el-switch @change="() => circuit.repeatAmount = 0" v-model="circuit.repeat" :name="'repeat' + index" active-text="Repeat" active-color="#e020aa"></el-switch>
                <input
                  v-if="circuit.repeat"
                  v-model="circuit.repeatAmount"
                  type="number"
                  placeholder="Ex. 2"
                  size="small"
                />
                <el-button
                  v-if="index > 0"
                  class="delete-btn"
                  type="danger"
                  plain
                  size="small"
                  @click.prevent="circuits.splice(circuits.map(item => ( item.key )).indexOf(circuit.key), 1)" circle icon="el-icon-delete"/>
              </div>
            </div>
            <el-row :gutter="16">
              <el-col :span="isMobile ? 24 : 8">
                <label>circuit name</label>
                <input type="text" v-model="circuit.cirName" placeholder="Circuit Name" />
              </el-col>
              <el-col :span="isMobile ? 12 : 8">
                <label>circuit type <span class="description">optional</span></label>
                <el-select v-model="circuit.cirType" placeholder="Select the workout type" filterable>
                  <el-option
                    v-for="item in types"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
              <el-col :span="isMobile ? 12 : 8">
                <label>circuit focus <span class="description">optional</span></label>
                <el-select v-model="circuit.cirFocus" placeholder="Select the workout type" filterable>
                  <el-option
                    v-for="item in focuses"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-col>
            </el-row>

            <div
              v-for="(exercise, index) in circuit.exercises"
              :key="index"
              :prop="'exercise.' + index + '.value'"
            >
              <hr/>
              <div class="title">
                <h3><i class="el-icon-collection-tag"/> {{ 'Exercise ' + (index + 1) }}</h3>
                <div class="title--actions">
                  <el-button
                  class="delete-btn"
                  type="danger"
                  plain size="small" @click.prevent="circuit.exercises.splice(circuit.exercises.map(item => ( item.key )).indexOf(exercise.key), 1)" circle icon="el-icon-delete"/>
                </div>
              </div>
              <el-row :gutter="16">
                <el-col :span="isMobile ? 24 : 10">
                  <label>exercise name</label>
                  <input v-model="exercise.name" type="text" placeholder="Ex. Situps or Fly/Chest Press Super Set"/>
                  <label>set type</label>
                  <el-select v-model="exercise.setType" placeholder="Select the set type" filterable>
                    <el-option
                      v-for="item in setTypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-col>
                <el-col :span="isMobile ? 24 : 10">
                    <label>description or instructions <span class="description">optional</span></label>
                    <el-input
                      type="textarea"
                      :rows="3"
                      placeholder="Optional exercise description"
                      v-model="exercise.exerciseDesc">
                    </el-input>
                  </el-col>
              </el-row>

              <template v-if="exercise.setType === 'Single Set'">
                <el-row :gutter="16">
                  <el-col :span="isMobile ? 24 : 6">
                    <el-switch v-model="exercise.equipment" :name="'equipment' + index" active-text="Equipment needed" active-color="#e020aa"></el-switch>
                  </el-col>
                  <el-col :span="isMobile ? 24 : 18" v-if="exercise.equipment === true">
                    <label>equipment description</label>
                    <input
                      v-model="exercise.equipDesc"
                      type="text"
                      placeholder="Ex. Bench, Dumbbells, Bands, Sliders, Etc."
                    />
                  </el-col>
                </el-row>

                <el-row class="sets" :gutter="16">
                  <el-col :span="isMobile ? 12 : 6">
                    <label>set amount <span class="description">ex. 3</span></label>
                    <el-input-number
                      v-model="exercise.setAmount"
                      type="number"
                      placeholder="Ex. 3"
                      :min="0"
                    />
                  </el-col>
                  <el-col :span="isMobile ? 12 : 6">
                    <label>rep amount <span class="description">ex. 8</span></label>
                    <el-input-number
                      v-model="exercise.repAmount"
                      type="number"
                      placeholder="Ex. 8"
                      :min="0"
                    />
                  </el-col>
                  <el-col :span="isMobile ? 12 : 6">
                    <label>exercise time <el-tooltip effect="dark" content="Length of each set" placement="top"><i class="el-icon-info"/></el-tooltip> <span class="description">in seconds</span></label>
                    <el-input-number
                      v-model="exercise.exerciseTime"
                      type="number"
                      placeholder="In seconds"
                      :min="0"
                      :step="5"
                      step-strictly
                    />
                  </el-col>
                  <el-col :span="isMobile ? 12 : 6">
                    <label>rest time <el-tooltip effect="dark" content="Length after each set" placement="top"><i class="el-icon-info"/></el-tooltip> <span class="description">in seconds</span></label>
                    <el-input-number
                      v-model="exercise.restTime"
                      type="number"
                      placeholder="In seconds"
                      :min="0"
                      :step="5"
                      step-strictly
                    />
                  </el-col>
                </el-row>
              </template>

              <template v-if="exercise.setType === 'Super Set'">
                <el-row :gutter="16">
                  <el-col :span="isMobile ? 24 : 6">
                    <el-switch v-model="exercise.equipment" :name="'equipment' + index" active-text="Equipment needed" active-color="#e020aa"></el-switch>
                  </el-col>
                  <el-col :span="isMobile ? 24 : 18" v-if="exercise.equipment === true">
                    <label>equipment description</label>
                    <input
                      v-model="exercise.equipDesc"
                      type="text"
                      placeholder="Ex. Bench, Dumbbells, Bands, Sliders, Etc."
                    />
                  </el-col>
                </el-row>

                <el-row class="sets" :gutter="16">
                  <el-col :span="24">
                    <h4>Super Set 1</h4>
                  </el-col>
                  <el-col :span="isMobile ? 12 : 6">
                    <label>set amount <span class="description">ex. 3</span></label>
                    <el-input-number
                      v-model="exercise.setAmount"
                      type="number"
                      placeholder="Ex. 3"
                      :min="0"
                    />
                  </el-col>
                  <el-col :span="isMobile ? 12 : 6">
                    <label>rep amount <span class="description">ex. 8</span></label>
                    <el-input-number
                      v-model="exercise.repAmount"
                      type="number"
                      placeholder="Ex. 8"
                      :min="0"
                    />
                  </el-col>
                  <el-col :span="isMobile ? 12 : 6">
                    <label>exercise time <el-tooltip class="item" effect="dark" content="Length of each set" placement="top"><i class="el-icon-info"/></el-tooltip> <span class="description">in seconds</span></label>
                    <el-input-number
                      v-model="exercise.exerciseTime"
                      type="number"
                      placeholder="In seconds"
                      :min="0"
                      :step="5"
                      step-strictly
                    />
                  </el-col>
                  <el-col :span="isMobile ? 12 : 6">
                    <label>rest time <el-tooltip class="item" effect="dark" content="Length after each set" placement="top"><i class="el-icon-info"/></el-tooltip> <span class="description">in seconds</span></label>
                    <el-input-number
                      v-model="exercise.restTime"
                      type="number"
                      placeholder="In seconds"
                      :min="0"
                      :step="5"
                      step-strictly
                    />
                  </el-col>
                </el-row>

                <el-row class="sets" :gutter="16">
                  <el-col :span="24">
                    <h4>Super Set 2</h4>
                  </el-col>
                  <el-col :span="isMobile ? 12 : 6">
                    <label>set amount <span class="description">ex. 3</span></label>
                    <el-input-number
                      v-model="exercise.setAmount2"
                      type="number"
                      placeholder="Ex. 3"
                      :min="0"
                    />
                  </el-col>
                  <el-col :span="isMobile ? 12 : 6">
                    <label>rep amount <span class="description">ex. 8</span></label>
                    <el-input-number
                      v-model="exercise.repAmount2"
                      type="number"
                      placeholder="Ex. 8"
                      :min="0"
                    />
                  </el-col>
                  <el-col :span="isMobile ? 12 : 6">
                    <label>exercise time <el-tooltip class="item" effect="dark" content="Length of each set" placement="top"><i class="el-icon-info"/></el-tooltip> <span class="description">in seconds</span></label>
                    <el-input-number
                      v-model="exercise.exerciseTime2"
                      type="number"
                      placeholder="In seconds"
                      :min="0"
                      :step="5"
                      step-strictly
                    />
                  </el-col>
                  <el-col :span="isMobile ? 12 : 6">
                    <label>rest time <el-tooltip class="item" effect="dark" content="Length after each set" placement="top"><i class="el-icon-info"/></el-tooltip> <span class="description">in seconds</span></label>
                    <el-input-number
                      v-model="exercise.restTime2"
                      type="number"
                      placeholder="In seconds"
                      :min="0"
                      :step="5"
                      step-strictly
                    />
                  </el-col>
                </el-row>
              </template>
            </div>
            <el-button class="add-exercise-btn" @click="addExercise(index)" type="primary" round size="small" plain icon="el-icon-plus">Add exercise</el-button>
            <el-button v-if="index == (circuits.length - 1)" @click="addCircuit(index, circuits.length)" type="default" round size="small" plain icon="el-icon-plus">Add circuit</el-button>
          </div>
        </template>

      </form>
      <div class="workout-form--actions">
        <el-button form="workoutForm" :disabled='woFormBtnDisabled' round :type="editWO ? 'warning' : 'primary'" native-type="submit">{{ woFormTwo ? (editWO ? 'Update Workout': 'Save Workout') : 'Next' }} <i class="el-icon-right"></i></el-button>
      </div>
    </template>
    <!-- end Add Workout -->

  </el-drawer>
</template>

<script>
import firebase from "firebase"

export default {
  props: {
    workoutsVisible: Boolean
  },
  data () {
    return {
      isMobile: '',
      woData: [],
      hideWorkouts: true,
      addWorkout: false,
      woFormOne: false,
      woFormTwo: false,
      editWO: false,
      types: [{
        value: 'Strength',
        label: 'Strength'
      }, {
        value: 'Cardio',
        label: 'Cardio'
      }, {
        value: 'Endurance',
        label: 'Endurance'
      }, {
        value: 'Flexibility',
        label: 'Flexibility'
      }],
      woName: '',
      woType: '',
      woFocus: '',
      woKey: Date.now(),
      focuses: [{
        value: 'Total Body',
        label: 'Total Body'
      }, {
        value: 'Upper Body',
        label: 'Upper Body'
      }, {
        value: 'Lower Body',
        label: 'Lower Body'
      }, {
        value: 'Core',
        label: 'Core'
      }, {
        value: 'Arms',
        label: 'Arms'
      }, {
        value: 'Shoulders',
        label: 'Shoulders'
      }, {
        value: 'Chest',
        label: 'Chest'
      }, {
        value: 'Back',
        label: 'Back'
      }],
      circuits: [{
        key: 0,
        cirName: '',
        cirType: '',
        cirFocus: '',
        repeat: false,
        repeatAmount: 0,
        exercises: [{
          key: 0,
          name: '',
          setType: '',
          equipment: false,
          equipDesc: '',
          exerciseDesc: '',
          setAmount: '0',
          repAmount: '0',
          exerciseTime: '0',
          restTime: '0',
          setAmount2: '0',
          repAmount2: '0',
          exerciseTime2: '0',
          restTime2: '0'
        }]
      }],
      addWorkoutText: "Let's add a new workout!",
      setTypes: [{
        value: 'Single Set',
        label: 'Single Set'
      }, {
        value: 'Super Set',
        label: 'Super Set'
      }]
    }
  },
  methods: {
    closeWorkouts(done) {
      this.$emit('hideWorkouts')
      done()
    },
    editWorkout(index, rows) {
      this.editWO = true

      let workout = rows[index]

      this.addWorkout = true
      this.woFormOne = true
      this.woName = workout.name
      this.woType = workout.type
      this.woFocus = workout.focus
      this.woKey = workout.key
      this.circuits = workout.circuits
    },
    deleteWorkout(index, rows) {
      rows.splice(index, 1)

      let uid = JSON.parse(localStorage.getItem('user')).uid
      
      firebase.database().ref(uid + '/workouts/' + rows[index].key).remove()
    },
    addCircuit(index) {
      this.circuits.push({
        key: index + 1,
        exercises: []
      })
    },
    addExercise(index) {
      this.circuits[index].exercises.push({
        key: this.circuits[index].exercises.length,
        setAmount: '0',
        repAmount: '0',
        exerciseTime: '0',
        restTime: '0',
        setAmount2: '0',
        repAmount2: '0',
        exerciseTime2: '0',
        restTime2: '0'
      })
    },
    startAddWorkout() {
      this.addWorkout = true
      this.woFormOne = true
      this.$nextTick(() => {
        this.$refs.workoutName.focus()
      })
    },
    backAddWorkout() {
      if (this.addWorkout === true && this.woFormOne === true) {
        this.addWorkout = false
        this. woFormOne = false
        this.woFormTwo = false
        this.circuits = [{
          key: 0,
          exercises: [{
            key: 0,
            equipment: false
          }]
        }]
        this.woName = ''
        this.woType = ''
        this.woFocus = ''
        this.editWO = false
        this.$nextTick(() => {
          this.addWorkoutText = "Let's add a new workout!"
        })
      } else if (this.addWorkout === true && this.woFormTwo === true) {
        this.woFormTwo = false
        this.woFormOne = true
        this.$nextTick(() => {
          this.addWorkoutText = "Let's add a new workout!"
        })
      }
    },
    workoutFormHandler() {
      if (this.addWorkout === true && this.woFormOne === true) {
        this.woFormOne = false
        this.woFormTwo = true
        this.$nextTick(() => {
          this.addWorkoutText = "Time to add circuits & exercises to your workout."
        })
      } else {
        
          let uid = JSON.parse(localStorage.getItem('user')).uid

          let workout = {
            name: this.woName,
            value: this.woName.toLowerCase(),
            label: this.woName,
            type: this.woType,
            focus: this.woFocus,
            key: this.woKey,
            circuits: this.circuits
          }
          
          // Creating new workout
          firebase.database().ref(uid + '/workouts/' + this.woKey).set(workout, (error) => {
            if (error) {
              console.log(error.message)
            } else {
              this.$message({
                message: (this.editWO === false ? 'Successfully created ' : 'Successfully updated ') + this.woName,
                type: 'success'
              })
            }
          }).then(() => {
            // Retrieve Workouts data
            firebase.database().ref().child(uid).child('workouts').get().then((snapshot) => {
              if (snapshot.exists()) {
                this.woData = Object.values(snapshot.val())
              }
            }).catch((error) => {
              console.error(error)
            })
            this.addWorkout = false
            this. woFormOne = false
            this.woFormTwo = false
            this.circuits = [{
              key: 0,
              exercises: [{
                key: 0,
                equipment: false,
                repAmount: '0',
                exerciseTime: '0',
                restTime: '0',
                setAmount2: '0',
                repAmount2: '0',
                exerciseTime2: '0',
                restTime2: '0'
              }]
            }]
            this.woName = ''
            this.woType = ''
            this.woFocus = ''
            this.woKey = Date.now()
            this.editWO = false
          })
      }
    }
  },
  computed: {
    woFormBtnDisabled: function() {
      if (this.woType == '' ||
      this.woFocus == '' ||
      this.woName.length < 3) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    // ****** isMobile
    // Define our viewportWidth variable
    let viewportWidth
    // Set/update the viewportWidth value
    let setViewportWidth = () => {
      viewportWidth = window.innerWidth || document.documentElement.clientWidth
    }
    // Log the viewport width into the console
    let logWidth = () => {
      if (viewportWidth > 991) {
        this.isMobile = false
      } else {
        this.isMobile = true
      }
    }
    // Set our initial width and log it
    setViewportWidth()
    logWidth()
    // On resize events, recalculate and log
    window.addEventListener('resize', () => {
      setViewportWidth()
      logWidth()
    }, false)
  },
  mounted() {
    let uid = JSON.parse(localStorage.getItem('user')).uid

    // Retrieve Workouts data
    firebase.database().ref().child(uid).child('workouts').get().then((snapshot) => {
      if (snapshot.exists()) {
        this.woData = Object.values(snapshot.val())
      } else {
        console.log('No workouts')
      }
    }).catch((error) => {
      console.error(error)
    })
  }
}
</script>

<style>
.wo-name-cell {
  white-space: nowrap;
  text-overflow: ellipsis;
}

.workout-header {
  display: flex;
  margin-top: 16px;
}

.workout-header + h2 {
  margin-bottom: 0;
}

.workout-header .workout-actions {
  display: flex;
  width: 100%;
}

.workout-header .workout-actions .add-workout-back-btn {
  margin-right: auto;
}
.workout-header .workout-actions .add-workout-btn {
  margin-left: auto;
}

.wo-table-dropdown .el-link.el-link--default {
  display: flex;
}

.wo-table-dropdown .el-link.el-link--default .el-link--inner {
  width: 100%;
}

.wo-table-dropdown .el-link.el-link--default .el-link--inner .el-dropdown-menu__item {
  width: 100%;
}

.el-dropdown-menu__item.delete-btn {
  color: #F56C6C;
}

.more-btn [class^=el-icon-] {
  transform: rotate(90deg);
}

/* Workout Form */
.workout-form--content {
  margin-top: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 16px;
}

.workout-form--actions {
  border-top: 1px solid #ebebeb;
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 16px;
}

.circuit > hr {
  border: 2px #405763 solid;
  margin-top: 32px;
  border-radius: 2px;
}

.title {
  align-items: center;
  display: flex;
  width: 100%;
}

.title h3 > [class*=el-icon] {
  color: #E6A23C;
}

.title .title--actions {
  align-items: center;
  display: flex;
  flex-grow: 1;
  margin-left: 8px;
}

.title .title--actions .el-switch,
.title .title--actions input[type=number] {
  margin-bottom: 0;
}

.title .title--actions input[type=number] {
  margin-left: 8px;
  padding-right: 0;
  width: 75px;
}

.title .title--actions .delete-btn {
  margin-left: auto;
}

.el-button.add-exercise-btn {
  margin-top: 16px;
}

.sets {
  margin-bottom: 16px;
}

.sets h4 {
  color: #99b5c3;
  font-size: 14px;
  letter-spacing: .5px;
  margin: 0;
  margin-bottom: 4px;
  text-transform: uppercase;
}

.sets .el-input input {
  margin-bottom: 0;
}

@media (max-width: 991px) {
  .wo-table-dropdown {
    border: 0;
    border-radius: 0 0 32px 32px;
    box-shadow: none;
    left: 0 !important;
    margin: 0 !important;
    overflow: hidden;
    padding: 12px 0;
    top: 0 !important;
    width: 100%;
  }

  .wo-table-dropdown .popper__arrow {
    display: none;
  }

  .wo-table-dropdown::before {
    animation: bg-transition .5s forwards;
    content: '';
    height: 100%;
    pointer-events: none;
    position: fixed !important;
    top: 0;
    width: 100%;
    z-index: -1;
  }

  @-webkit-keyframes bg-transition {
    0%{background: rgba(0, 0, 0, 0)}
    60%{background: rgba(0, 0, 0, 0)}
    100%{background: rgba(0, 0, 0, .5)}
  }
  @-moz-keyframes bg-transition {
    0%{background: rgba(0, 0, 0, 0)}
    60%{background: rgba(0, 0, 0, 0)}
    100%{background: rgba(0, 0, 0, .5)}
  }
  @keyframes bg-transition {
    0%{background: rgba(0, 0, 0, 0)}
    60%{background: rgba(0, 0, 0, 0)}
    100%{background: rgba(0, 0, 0, .5)}
  }

  .wo-table-dropdown::after {
    background: #fff;
    border-radius: 0 0 32px 32px;
    content: '';
    height: 100%;
    position: absolute !important;
    top: 0;
    width: 100%;
    z-index: -1;
  }
}
</style>